import { Dayjs } from 'dayjs';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../dto/data-model-utils.js';
import { TimeZone } from '../../../time/timezone.js';

export class BusinessLevelMarketingSubscriptionRequest extends DataModel {
  static readonly TYPE_ID: string = 'c3224973e03644dd9f1bf217c9c94a52';

  private constructor(
    public readonly creationDate: Dayjs,
    public readonly businessRef: BusinessModuleRef,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessLevelMarketingSubscriptionRequest.TYPE_ID;
  }

  static create(args: {
    creationDate: Dayjs,
    businessRef: BusinessModuleRef,
  }): BusinessLevelMarketingSubscriptionRequest {
    return new BusinessLevelMarketingSubscriptionRequest(
        args.creationDate,
        args.businessRef,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessLevelMarketingSubscriptionRequest {
    return this.create({
      creationDate: context.decodeDate(MapUtils.getNumber(map, 'creationDate')),
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      creationDate: context.encodeDate(this.creationDate),
      businessRef: this.businessRef.encode(),
    };
  }

  clone(): this {
    return BusinessLevelMarketingSubscriptionRequest.create({
      businessRef: cloneData(this.businessRef),
      creationDate: TimeZone.cloneDate(this.creationDate),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
      other.creationDate === this.creationDate;
  }
}

export class BusinessLevelMarketingSubscriptionRequestBuilder extends DataModelBuilder<BusinessLevelMarketingSubscriptionRequest> {
  build(context: SerializationContext, map: SerializedData): BusinessLevelMarketingSubscriptionRequest {
    return BusinessLevelMarketingSubscriptionRequest.fromMap(context, map);
  }
}
